goog.provide("shadow.js.shim.module$src$svg$objects$megaphone_svg$default");
shadow.js.shim.module$src$svg$objects$megaphone_svg$default = shadow.js.shim.module$src$svg$objects$megaphone_svg.default;
